<template>
	<div>
		<span>
			<b-button v-on:click="edit()" size="sm" variant="outline-light">
				<Icon icon="material-symbols:edit" width="20" height="20" v-b-tooltip.hover.bottom="$t('Edit')" color="#7367F0" />
			</b-button>
		</span>
		<span> 
			<b-button v-on:click="deleteData()" size="sm" variant="outline-light"> 
				<Icon icon="ic:baseline-remove-circle" width="20" height="20" v-b-tooltip.hover.bottom="$t('Delete')"
					color="#ea5455" />
			</b-button>
		</span>
		<span>
			<b-button v-on:click="addInfo()" size="sm" variant="outline-light">
				<Icon :icon="params.addIcon" width="20" height="20" v-b-tooltip.hover.bottom="$t('AddNew')" color="#FF9F43" />
			</b-button>
		</span>
	</div>
</template>
<script>
import { Icon } from "@iconify/vue2";
export default {
	props: ["addMethods", "addIcon"],
	components: { Icon },
	methods: {
		edit() {   this.$root.$emit("editData", this.params.data); },
		deleteData() { this.$root.$emit("deleteData", this.params.data); },
		addInfo() { this.$root.$emit(this.params.addMethods, this.params.data); }
	}
}
</script>